import React, { forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';

import { embedCode as TEXT } from 'locales/en';
import CodeWithCopy from 'components/CodeWithCopy';

const EmbedCode = forwardRef(({ id, className, buttonText }, ref) => {
  const scriptRef = useRef(null);
  const htmlElementRef = useRef(null);

  return (
    <div
      ref={ref}
      className={`transition-all ${className}`}
      data-testid="embed-code-container"
    >
      <p className="lg:text-lg text-base font-semibold text-javelin-gray-dark">
        {TEXT.header}
      </p>
      <ol className="list-decimal text-sm text-javelin-gray-light ml-3">
        <li className="lg:text-sm text-xs text-javelin-gray-light mt-2">
          <p dangerouslySetInnerHTML={{ __html: TEXT.step1 }} />
          <CodeWithCopy
            ref={scriptRef}
            content={`<script src="${process.env.REACT_APP_EMBED_LINK}"></script>`}
            testId="copy-script"
          />
        </li>
        <li className="lg:text-sm text-xs text-javelin-gray-light mt-2">
          <p>{TEXT.step2}</p>
          <CodeWithCopy
            ref={htmlElementRef}
            content={`<javelin-checkout product-id="${id}" button-text="${buttonText}"
            button-color="#3b89f7" />`}
            testId="copy-html"
          />
        </li>
      </ol>
    </div>
  );
});

EmbedCode.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  buttonText: PropTypes.string,
};
EmbedCode.defaultProps = {
  className: 'border-t border-gray-200 p-5 lg:p-12',
  buttonText: 'Donate Now',
};

export default EmbedCode;
